<template>
  <div class="modal" :class="{ 'modal--active': show }" @click.prevent="close">
    <div class="modal__container">
      <a href="#!" class="modal__close" aria-label="modal close" @click.prevent="close" />
      <div class="modal__inner" @click.stop>
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	mounted: function () {
		document.addEventListener("keydown", (e) => {
			if (this.show && e.keyCode == 27) {
				this.close();
			}
		});
	},
	methods: {
		close: function () {
			this.$emit('close');
		}
	}
};
</script>
